import { css } from '@linaria/core';

const wrapper = css`
  color: #b10e1e;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  margin-bottom: 5px;
`;

export default function FormError(props) {
  return (
    <div aria-live="assertive" className={wrapper} role="alert">
      {props.children}
    </div>
  );
}
